<template>

<b-modal ref="bModal" :id="modalId" @hidden="onHidden" :title="title" size="xl" header-bg-variant="primary" header-text-variant="light">
  <work-order-form v-model="workOrder" @onDateModified="updateOtherWorkOrder" @cambioProyecto="cambioProyecto()"></work-order-form>

  <template slot="modal-footer">
    <div class="mr-auto">
      <b-button @click="$refs.bModal.hide()" variant="secondary">Cancelar</b-button>
    </div>
    <div>
      <b-button :disabled="!dirty" @click="onModify" variant="primary">Modificar y Confirmar</b-button>

      <b-button :disabled="dirty" @click="onConfirm" variant="success">Confirmar</b-button>

      <b-button v-if="permisoDelete" @click="onDelete" variant="danger">Eliminar</b-button>
    </div>
  </template>
  <div>
    <b-card no-body>
      <b-tabs card v-model="tab">
        <b-tab title="Historial de cambios" active>
          <work-order-version-table :versions="versions" :workOrderType="workOrder.workOrderType" />
        </b-tab>
        <b-tab title="Otros partes del proyecto">
          <project-others-partials-table :partials="partialsProject"/>
        </b-tab>
        <b-tab title="Otros partes del operario">
          <user-others-partials-table :partials="partialsUser"/>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</b-modal>

</template>

<script>

import IconInput from '@/components/common/IconInput'
import WorkOrderForm from './WorkOrderForm'
import WorkOrderVersionTable from '@/components/workOrderVersion/WorkOrderVersionTable'
import ProjectOthersPartialsTable from '@/components/projectOthersPartials/ProjectOthersPartialsTable'
import UserOthersPartialsTable from '@/components/userOthersPartials/UserOthersPartialsTable'
import api from '@/api/api'
import moment from 'moment'
import {session} from '@/auth'

export default {
  name: 'EditWorkOrderModal',
  components: {
    WorkOrderVersionTable,
    WorkOrderForm,
    IconInput,
    ProjectOthersPartialsTable,
    UserOthersPartialsTable
  },
  props: {
    modalId: {type: String, required: true},
    initialWorkOrder: {required: true}
  },
  data: function() {
    return {
      tab: 0,
      id: null,
      idProject: null,
      idEmployee: null,
      workOrderDate: null,
      versions: [],
      partialsProject: [],
      partialsUser: [],
      dirty: false,
      workOrder: {...this.initialWorkOrder}
    }
  },
  computed: {
    title() {
      return 'Parte de trabajo: PT' + this.workOrder.id + ' - ' + this.workOrder.typeLabel
    },
    permisoDelete() {
      if ((session.authorities != null) && session.authorities.includes('ROLE_WORK_ORDER_DELETE')) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    show(workOrder) {
      this.workOrder = workOrder
      this.tab = 0
      this.loadVersions()
      this.loadProjectOthersPartials()
      this.loadUserOthersPartials()
      this.$refs.bModal.show()
    },
    onHidden() {
      this.workOrder = {...this.initialWorkOrder}
      this.dirty = false
    },
    onModify() {
      this.$emit('modify', this.workOrder)
      this.$refs.bModal.hide()
    },
    onConfirm() {
      this.$emit('confirm', this.initialWorkOrder)
      this.$refs.bModal.hide()
    },
    async loadVersions() {
      this.versions = await api.workOrder.getVersions(this.workOrder.id)
    },
    async loadProjectOthersPartials() {
      const date = moment.parseZone(this.workOrder.workOrderDate, 'YYYY-MM-DD').utc().format()
      this.partialsProject = await api.workOrder.projectOthersPartials(this.workOrder.id, this.workOrder.projectId, date)
    },
    async loadUserOthersPartials() {
      const date = moment.parseZone(this.workOrder.workOrderDate, 'YYYY-MM-DD').utc().format()
      this.partialsUser = await api.workOrder.userOthersPartials(this.workOrder.id, this.workOrder.employeeId, date)
    },
    updateOtherWorkOrder() {
      this.loadProjectOthersPartials()
      this.loadUserOthersPartials()
    },
    onDelete() {
      this.$emit('delete', this.initialWorkOrder)
      this.$refs.bModal.hide()
    },
    cambioProyecto() {
      this.$emit('cambioProyecto')
      this.$refs.bModal.hide()
    }
  },
  watch: {
    initialWorkOrder: function(value) {
      this.workOrder = {...value}
    },
    workOrder: {
      deep: true,
      handler: function(val, oldVal) {
        if (val === oldVal) { // if they are the same object, that means a property changed
          this.dirty = true
        }
      }
    }
  }
}

</script>

<style lang="scss">

.project-name {
  font-weight: bold;
  color: #707070;
}

div#editModal___BV_modal_content_ {
  min-width: 1050px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/workOrder/partials/EditWorkOrderModal.vue